export const CONTACT = {
  phone: '09 80 80 36 84',
  phoneHref: 'tel:+33980803684',
  whatsapp: '07 45 88 33 92',
  whatsappHref: 'https://wa.me/33745883392?text=Bonjour%2C%20je%20souhaite%20un%20diagnostic%20pour%20un%20probl%C3%A8me%20de%20nuisibles',
  whatsappMessage: 'Bonjour, je souhaite un diagnostic pour un problème de nuisibles.',
};